document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".rbs").forEach(initRbs);
});

function initRbs(root) {
  const track = root.querySelector(".rbs__track");
  const slides = Array.from(root.querySelectorAll(".rbs__slide"));
  const prevBtn = root.querySelector("[data-rbs-prev]");
  const nextBtn = root.querySelector("[data-rbs-next]");
  const dots = Array.from(root.querySelectorAll("[data-rbs-dot]"));

  if (!track || slides.length <= 1) return;

  // Enforce the horizontal layout even if theme CSS overrides it
  track.style.display = "flex";
  track.style.transition = "transform 450ms ease";
  track.style.willChange = "transform";
  track.style.scrollSnapType = "none";
  slides.forEach((s) => {
    s.style.flex = "0 0 100%";
    s.style.width = "100%";
  });

  let index = 0;
  let timer = null;

  const autoplay = root.dataset.autoplay === "true";
  const interval = Number(root.dataset.interval) || 5000;

  function updateUI() {
    track.style.transform = `translate3d(${-100 * index}%, 0, 0)`;

    dots.forEach((d, i) => {
      const active = i === index;
      d.classList.toggle("is-active", active);
      d.setAttribute("aria-current", active ? "true" : "false");
    });

    slides.forEach((s, i) => {
      s.setAttribute("aria-hidden", i === index ? "false" : "true");
    });
  }

  function goTo(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    updateUI();
  }

  function stop() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  function start() {
    if (!autoplay || slides.length <= 1) return;
    stop();
    timer = window.setInterval(() => goTo(index + 1), interval);
  }

  if (prevBtn) prevBtn.addEventListener("click", () => goTo(index - 1));
  if (nextBtn) nextBtn.addEventListener("click", () => goTo(index + 1));

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      const i = Number(dot.getAttribute("data-rbs-dot"));
      if (!Number.isNaN(i)) goTo(i);
    });
  });

  // Pause autoplay on interaction (doesn't affect page scroll)
  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);
  root.addEventListener("touchstart", stop, { passive: true });
  root.addEventListener("touchend", start, { passive: true });

  updateUI();
  start();
}